import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { HTTP } from "./utils/http";
import VanHeader from "./components/header.vue";
import {
  Skeleton,
  Lazyload,
  Loading,
  List,
  Toast,
  Tag,
  PullRefresh,
  Tabbar,
  TabbarItem,
  Swipe,
  field,
  Icon,
  SwipeItem,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  SubmitBar,
  Stepper,
  Dialog,
  Radio,
  RadioGroup,
  Grid,
  GridItem,
  Cell,
  Uploader,
  Field,
  Button,
  ActionSheet,
  DatetimePicker,
  Picker,
  Popup,
  Progress,
  Checkbox,
  CheckboxGroup,
  Tabs,
  Tab,
  ImagePreview,
  Image as VanImage,
  Switch,
  Search,
  NoticeBar,
  CountDown,
  Overlay,
  Form,
  Col,
  Row,
  Popover,
  NavBar
} from "vant";
Vue.use(Skeleton)
  .use(Lazyload)
  .use(Loading)
  .use(PullRefresh)
  .use(Toast)
  .use(List)
  .use(field)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Swipe)
  .use(SwipeItem)
  .use(GoodsAction)
  .use(GoodsActionIcon)
  .use(GoodsActionButton)
  .use(SubmitBar)
  .use(Stepper)
  .use(Dialog)
  .use(Icon)
  .use(Radio)
  .use(RadioGroup)
  .use(Grid)
  .use(GridItem)
  .use(Cell)
  .use(Uploader)
  .use(Field)
  .use(Button)
  .use(ActionSheet)
  .use(DatetimePicker)
  .use(Picker)
  .use(Popup)
  .use(Progress)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Tag)
  .use(Tabs)
  .use(Tab)
  .use(ImagePreview)
  .use(VanImage)
  .use(Switch)
  .use(Search)
  .use(NoticeBar)
  .use(CountDown)
  .use(Overlay)
  .use(Form)
  .use(Col)
  .use(Row)
  .use(Popover)
  .use(NavBar);

import {
  Dropdown as ElDropdown,
  DropdownMenu as ElDropdownMenu,
  DropdownItem as ElDropdownItem,
  DatePicker as ELDatePicker,
  Popover as ElPopover,
  Form as ElForm,
  FormItem as ElFormItem,
  Input as ElInput,
  Select as ElSelect,
  Option,
  OptionGroup,
  Cascader
} from 'element-ui'
Vue.prototype.$ELEMENT = { size: 'medium', zIndex: 3000 };
Vue.use(ElDropdown)
  .use(ElDropdownMenu)
  .use(ElDropdownItem)
  .use(ELDatePicker)
  .use(ElPopover)
  .use(ElForm)
  .use(ElFormItem)
  .use(ElInput)
  .use(ElSelect)
  .use(Option)
  .use(OptionGroup)
  .use(Cascader);

import jsonp from "vue-jsonp";
import '@vant/touch-emulator'; // vant桌面端适配
import 'tcplayer.js/dist/tcplayer.min.css';

Vue.use(jsonp);

import VConsole from "vconsole";

// new VConsole();

Vue.component("VanHeader", VanHeader);


Vue.directive('title', {
  update: function (el, binding) {
    document.title = binding.value
  }
})

Vue.config.productionTip = false;
Vue.prototype.http = axios;
Vue.prototype.$axios = new HTTP();

// const bus = new Vue()
// Vue.prototype.Bus = bus

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
